import { cn } from "@/lib/utils";
import { Skeleton } from "./ui/skeleton";

export default function PageSkeleton({
  className = "",
  lines = 4,
}: {
  className?: string;
  lines?: number;
}) {
  return (
    <div className={cn("mt-5", className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className="my-3 h-4" />
      ))}
    </div>
  );
}
